import { applyFilters, doRequest } from "./helpers";

export default class CampaignTargetService {
  static async getContacts(campaign_id, entity_id, filters = null) {
    let path = `/campaign/${campaign_id}/target/${entity_id}/contacts`;
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }
}
